(function () {
  function updateGallery(button) {
    var gallery = button.closest('[data-oj-product-gallery]');
    if (!gallery) return;

    var target = gallery.querySelector('[data-oj-product-media-current]');
    var template = button.querySelector('[data-oj-product-media-template]');
    if (!target || !template) return;

    target.innerHTML = template.innerHTML;

    gallery.querySelectorAll('[data-oj-product-media-thumb]').forEach(function (thumb) {
      thumb.classList.remove('is-active');
      thumb.removeAttribute('aria-current');
    });

    button.classList.add('is-active');
    button.setAttribute('aria-current', 'true');
  }

  function updateForm(select) {
    var form = select.closest('[data-oj-product-form]');
    if (!form) return;

    var option = select.options[select.selectedIndex];
    var available = option && option.getAttribute('data-available') === 'true';
    var submit = form.querySelector('.js-oj-product-submit');
    var submitText = form.querySelector('.js-oj-product-submit-text');
    var root = form.closest('[data-oj-product-root]');
    var sku = option ? option.getAttribute('data-sku') : '';
    var price = root ? root.querySelector('[data-oj-product-price]') : null;
    var variantsScript = root ? root.querySelector('[data-oj-product-variants]') : null;
    var variants = [];
    var selectedVariant = null;

    if (variantsScript) {
      try {
        variants = JSON.parse(variantsScript.textContent || '[]');
      } catch (error) {
        variants = [];
      }
    }

    if (option) {
      variants.some(function (variant) {
        if (String(variant.id) === String(option.value)) {
          selectedVariant = variant;
          return true;
        }

        return false;
      });
    }

    if (selectedVariant) {
      available = selectedVariant.available === true;
      sku = selectedVariant.sku || '';
      if (price) {
        price.innerHTML = selectedVariant.price_html || '';
      }
    }

    if (submit) submit.disabled = !available;
    if (submitText) submitText.textContent = available ? 'Dodaj u korpu' : 'Nije dostupno';

    if (root) {
      root.querySelectorAll('[data-oj-product-sku]').forEach(function (node) {
        node.textContent = sku || '';
      });
    }
  }

  function updateRequestForm(select) {
    var form = select.closest('[data-oj-request-form]');
    if (!form) return;

    var option = select.options[select.selectedIndex];
    if (!option) return;

    var root = form.closest('[data-oj-product-root]');
    var variantId = option.value || '';
    var variantTitle = option.getAttribute('data-variant-title') || option.textContent.trim();
    var sku = option.getAttribute('data-variant-sku') || '';

    form.querySelectorAll('[data-oj-request-variant-id]').forEach(function (field) {
      field.value = variantId;
    });

    form.querySelectorAll('[data-oj-request-variant-title]').forEach(function (field) {
      field.value = variantTitle;
    });

    form.querySelectorAll('[data-oj-request-variant-sku]').forEach(function (field) {
      field.value = sku;
    });

    form.querySelectorAll('[data-oj-whatsapp-link]').forEach(function (link) {
      var number = link.getAttribute('data-whatsapp-number') || '';
      var location = link.getAttribute('data-whatsapp-location') || '';
      var productTitle = link.getAttribute('data-product-title') || '';
      var productUrl = link.getAttribute('data-product-url') || '';
      var message;

      if (!number || !location || !productTitle || !productUrl) return;

      message = 'Pozdrav, zanima me cijena za ' + productTitle + '.';
      if (link.getAttribute('data-oj-whatsapp-variant-enabled') === 'true' && variantTitle) {
        message += '\nVarijanta: ' + variantTitle;
      }
      message += '\nRadnja: ' + location;
      message += '\nLink proizvoda: ' + productUrl;

      link.href = 'https://wa.me/' + number + '?text=' + encodeURIComponent(message);
    });

    if (root) {
      root.querySelectorAll('[data-oj-product-sku]').forEach(function (node) {
        node.textContent = sku;
      });
    }
  }

  document.addEventListener('change', function (event) {
    if (event.target && event.target.matches('.js-oj-product-variant')) {
      updateForm(event.target);
    }

    if (event.target && event.target.matches('.js-oj-request-variant')) {
      updateRequestForm(event.target);
    }
  });

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest('[data-oj-product-media-thumb]');
    if (button) {
      updateGallery(button);
    }
  });
})();